module.exports = __webpack_public_path__ + "media/2022/HERO-02-0bad1ff7.jpg";